import React from 'react';
import Pages from './routes';

const App = () => {
  return <Pages />;
};

export default App;
